import { AbstractControl } from '@angular/forms';

export const CustomRequired = (control: AbstractControl): {[key: string]: any} => {

  const error = {
    invalidRequired: true,
    message: 'This value is required'
  };

  try {
    let value = control.value;
    if (value === undefined || value === NaN || value === null || value === '') {
      return  error;
    }

    if (typeof value === 'string') {
      value = value.trim();
    }

    return  value.toString().length ? null :  error;

  } catch (error) {
  }

};



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/custom-validators/components/required/required-validator.ts